import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PlayerCard } from '../constants';
import API from '../services';
import { RootState } from '.';

type PartialCard = Partial<PlayerCard>;

export type CardState = {
  defaultCardInfo: PlayerCard;
  isGettingCardsInfo: boolean;
};

const initialCard: CardState = {
  defaultCardInfo: {
    figure_id: 0,
  } as PlayerCard,
  isGettingCardsInfo: false,
};

export const getCardsInfo = createAsyncThunk('card/getCardsInfo', async (aid: string) => {
  const { data } = await API.current!.card.getCards(aid);
  return data;
});

export const updateCard = createAsyncThunk<
  any,
  {
    aid: string;
    info: PartialCard;
  },
  { state: RootState }
>('card/updateCard', async ({ aid, info }, { dispatch, getState }) => {
  const res = await API.current!.card.updateCard(aid, {
    ...info,
  });
  dispatch(setDefaultCardInfo(info));
  return res?.data;
});

const card = createSlice({
  name: 'card',
  initialState: initialCard,
  reducers: {
    setDefaultCardInfo(state, { payload }: PayloadAction<Partial<PlayerCard>>) {
      state.defaultCardInfo = {
        ...state.defaultCardInfo,
        ...payload,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCardsInfo.pending, state => {
        state.isGettingCardsInfo = true;
      })
      .addCase(getCardsInfo.fulfilled, (state, action) => {
        state.isGettingCardsInfo = false;
        state.defaultCardInfo = action.payload ?? ({} as PlayerCard);
      });
  },
});

export const { setDefaultCardInfo } = card.actions;

export default card.reducer;
